import { registrationEmailUtmParameters } from "../send/sendRegisterEmail"
import { thankYou } from "./subDefinitions/emailComponents"
import moment from "moment"
import "moment/locale/cs"
import { generateButtonPdfVoucherLink } from "./subDefinitions/generateButtonPdfVoucherLink"
import { generateEmailCallToActionButton, generateEmailParagraph, generateEmailText, spaceDivider } from "../generateEmailParagraph"
import { getOpenCoursesOffer } from "./subDefinitions/openCoursesOffer"

moment.locale("cs")

const emailDefinition1RegisterIntoOnlineSampleCourseSubject = "Potvrzení registrace do ukázkové lekce, Vzdělání budoucnosti"

export const emailDefinition1RegisterIntoOnlineSampleCourse = (
  courseTitle: string,
  when: string,
  courseDetailPageUrl: string,
  technologyPageUrl: string,
  courseListOffer: string,
  downloadPdfVoucherUrl?: string
): { body: string; subject: string } => ({
  body: `
    ${generateEmailParagraph("Dobrý den, ")}
    
    ${generateEmailParagraph(
      `s radostí Vám oznamujeme, že jste úspěšně zaregistrovaný(á) do online ukázkové lekce <strong>"${courseTitle}"</strong>, která byla provedena dne ${moment().format(
        "l"
      )}.`
    )}
    ${generateEmailText(
      "Tato lekce je skvělou příležitostí pro oba z Vás zjistit, zda náš kurz vyhovuje Vašim očekáváním a potřebám. Tato lekce Vám poskytne přehled o obsahu kurzu a metodě výuky, abyste mohli společně rozhodnout, zda je tento kurz správnou volbou pro rozvoj zájmů a dovedností Vašeho dítěte. V případě, že se Vám bude kurz zdát vhodný, budeme rádi, když se rozhodnete pro další vzdělávací cestu s námi."
    )}
    ${generateEmailCallToActionButton("Více informací", "Více informací", `${technologyPageUrl}${registrationEmailUtmParameters}`)} 
    
    ${generateEmailText(`<strong>Datum a čas konání ukázkové lekce:</strong>`)}
    ${generateEmailParagraph(when)}
    
    ${generateEmailText(`<strong>Forma:</strong>`)}
    ${generateEmailParagraph(`Online setkání skrze platformu Google Meet.`)}    
    
    ${generateEmailText(`<strong>Přípravy:</strong>`)}
    ${generateEmailParagraph(`Pro tipy a návody, jak se připravit na konkrétní předmět kurzu, navštivte naši rubriku návody na blogu:`)}
    
    ${generateEmailCallToActionButton(
      "Získejte užitečné tipy",
      "Získejte užitečné tipy",
      `https://vzdelanibudoucnosti.cz/blog/stitek/navod${registrationEmailUtmParameters}`
    )}
    
    ${generateEmailParagraph(`Více informací o lekci naleznete na našich webových stránkách.`)}
    
    ${generateEmailCallToActionButton("Více informací o lekci", "Více informací o lekci", `${courseDetailPageUrl}${registrationEmailUtmParameters}`)}
    
    ${generateButtonPdfVoucherLink(downloadPdfVoucherUrl)}
    
    ${spaceDivider}
    ${getOpenCoursesOffer(courseListOffer)}
    
    ${thankYou}
  `,
  subject: emailDefinition1RegisterIntoOnlineSampleCourseSubject
})
